<template>

	<div class="contain">
		<!-- <el-scrollbar style="height:100%;"> -->
		<div>
			<el-row>
				<el-col :span="24" class="bold-head">添加监测数据</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(1)接口说明 :</span>在添加老人的基础上添加</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(2)请求方式 :</span> post</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(3)Url :</span> http://121.46.26.109:8060/api/sendHealthData </el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">header</el-col>
			</el-row>
			<my-table :tableData="tableOne" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">body</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.0:请求</el-col>
			</el-row>
			<my-table :tableData="tableTwo" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.1:健康护理床位</el-col>
			</el-row>
			<my-table :tableData="tableHealth" class="table-contain"></my-table>

			<el-row>
				<el-col :span="24" class="bold">（4）示例</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"15",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"deviceSid": "123",</el-col>
				<el-col :span="24">"heartRate": 78,</el-col>
				<el-col :span="24">"breathe": 30,</el-col>
				<el-col :span="24">"bodyStatus": 1,</el-col>
				<el-col :span="24">"bodyDynamicValue": 1,</el-col>
				<el-col :span="24">"batteryCapacity":"0xff"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">成功返回</el-col>
			</el-row>
			<div>
				<el-row class="contain-bg">
					<el-col :span="24">{</el-col>
					<el-col :span="24">"success": 1,</el-col>
					<el-col :span="24">"message": "新增成功"</el-col>
					<el-col :span="24">}</el-col>
				</el-row>
			</div>
			<el-row>
				<el-col :span="24" class="bold">1.1 血压</el-col>
			</el-row>
			<my-table :tableData="tableYa" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.2 血糖</el-col>
			</el-row>
			<my-table :tableData="tableTang" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.3 体重</el-col>
			</el-row>
			<my-table :tableData="tableWeight" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.4 身体指数</el-col>
			</el-row>
			<my-table :tableData="tableBody" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.5 血脂</el-col>
			</el-row>
			<my-table :tableData="tableZhi" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.6 血尿酸</el-col>
			</el-row>
			<my-table :tableData="tableSuan" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.7 血氧</el-col>
			</el-row>
			<my-table :tableData="tableYang" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.8 心电</el-col>
			</el-row>
			<my-table :tableData="tableHert" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.9 呼吸率</el-col>
			</el-row>
			<my-table :tableData="tableHu" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.10 精神指数</el-col>
			</el-row>
			<my-table :tableData="tableJS" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.11 皮肤指数</el-col>
			</el-row>
			<my-table :tableData="tablePi" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">1.12 体温</el-col>
			</el-row>
			<my-table :tableData="tableWen" class="table-contain"></my-table>
			<el-row>
				<el-col :span="24" class="bold">（4）示例</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1. 请求</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.1 血压</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="8">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"1",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"highValue": 138,</el-col>
				<el-col :span="24">"lowValue": 78,</el-col>
				<el-col :span="24">"pulseValue": 70,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "正常高值"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.2 血糖</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="8">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"2",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"sugarValue": 7.6,</el-col>
				<el-col :span="24">"typeCode": 1,</el-col>
				<el-col :span="24">"typeDetailCode": 3,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.3 体重</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"3",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"hightVlaue": 178,</el-col>
				<el-col :span="24">"weightValue": 75,</el-col>
				<el-col :span="24">"bmi": 23.1,</el-col>
				<el-col :span="24">"level": 0,</el-col>
				<el-col :span="24">"levelName": "正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.4 身体指数</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"6",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"bodyFatValue": 80.1,</el-col>
				<el-col :span="24">"bmi": 20.1,</el-col>
				<el-col :span="24">"bmr": 20.1,</el-col>
				<el-col :span="24">"bodyWater": 80.1,</el-col>
				<el-col :span="24">"bone": 10.1,</el-col>
				<el-col :span="24">"skinFat": 8.1,</el-col>
				<el-col :span="24">"visceralFat": 6.1,</el-col>
				<el-col :span="24">"muscle": 8.1,</el-col>
				<el-col :span="24">"bodyAge": 18,</el-col>
				<el-col :span="24">"level": 0,</el-col>
				<el-col :span="24">"levelName": "正常",</el-col>
				<el-col :span="24">"bmiLevel": 0,</el-col>
				<el-col :span="24">"bmiLevelName": "正常",</el-col>
				<el-col :span="24">"bmrLevel": 0,</el-col>
				<el-col :span="24">"bmrLevelName": "未达标",</el-col>
				<el-col :span="24">"bodyWaterLevel": 1,</el-col>
				<el-col :span="24">"bodyWaterLevelName": "偏低",</el-col>
				<el-col :span="24">"boneLevel": 1,</el-col>
				<el-col :span="24">"boneLevelName": "偏低",</el-col>
				<el-col :span="24">"skinFatLevel": 1,</el-col>
				<el-col :span="24">"skinFatLevelName": "偏低",</el-col>
				<el-col :span="24">"visceralFatLevel": 1,</el-col>
				<el-col :span="24">"visceralFatLevelName": "标准",</el-col>
				<el-col :span="24">"muscleLevel": 1,</el-col>
				<el-col :span="24">"muscleLevelName": "偏低",</el-col>
				<el-col :span="24">"bodyAgeLevel": 1,</el-col>
				<el-col :span="24">"bodyAgeLevelName": "小于实际年龄"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.5 血脂</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"7",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"cholValue": 5.1,</el-col>
				<el-col :span="24">"trigValue": 1.7,</el-col>
				<el-col :span="24">"hdlValue": 1.0,</el-col>
				<el-col :span="24">"ldlValue": 3.3,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "正常",</el-col>
				<el-col :span="24">"cholLevel": 0,</el-col>
				<el-col :span="24">"cholLevelName": "正常",</el-col>
				<el-col :span="24">"hdlLevel": 0,</el-col>
				<el-col :span="24">"hdlLevelName": "正常",</el-col>
				<el-col :span="24">"ldlLevel": 0,</el-col>
				<el-col :span="24">"ldlLevelName": "正常",</el-col>
				<el-col :span="24">"trigLevel": 0,</el-col>
				<el-col :span="24">"trigLevelName": "正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.6 血尿酸</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"8",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"buaValue": 300,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.7 血氧</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="2">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"9",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"spoValue": 80,</el-col>
				<el-col :span="24">"level": 0,</el-col>
				<el-col :span="24">"levelName": "低氧血症"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.8 心电</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"10",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"heartRate": 80,</el-col>
				<el-col :span="24">"leakCount": 80,</el-col>
				<el-col :span="24">"stopCount": 80,</el-col>
				<el-col :span="24">"irregularCount": 80,</el-col>
				<el-col :span="24">"fastCount": 80,</el-col>
				<el-col :span="24">"slowCount": 80,</el-col>
				<el-col :span="24">"filteredEcgPoints":"XXXXXXXX",</el-col>
				<el-col :span="24">"level": 6,</el-col>
				<el-col :span="24">"levelName": "窦性心动正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.9 呼吸率</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"11",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"breathFreq": 60.5,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "呼吸过缓"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.10 精神指数</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"12",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"testType": "fatigue",</el-col>
				<el-col :span="24">"level": 1}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.11 皮肤指数</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"13",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"waterPercent": "62.5",</el-col>
				<el-col :span="24">"oilPercent": "20.5",</el-col>
				<el-col :span="24">"bodyPart": "1",</el-col>
				<el-col :span="24">"waterPercentLevel": "2",</el-col>
				<el-col :span="24">"waterPercentLevelName": "正常",</el-col>
				<el-col :span="24">"oilPercentLevel": "3",</el-col>
				<el-col :span="24">"oilPercentLevelName": "偏油"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">1.12 体温</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"recordId":"1",</el-col>
				<el-col :span="24">"areaName":"南京",</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"type":"14",</el-col>
				<el-col :span="24">"time":"2018-06-26 00:00:00",</el-col>
				<el-col :span="24">"collectType":1,</el-col>
				<el-col :span="24">"deviceType":"2",</el-col>
				<el-col :span="24">"deviceSid":"15",</el-col>
				<el-col :span="24">"body":{</el-col>
				<el-col :span="24">"bodyTemperature": 36.2,</el-col>
				<el-col :span="24">"level": 1,</el-col>
				<el-col :span="24">"levelName": "正常"}</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">2. 响应</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">成功返回</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"success": 1,</el-col>
				<el-col :span="24">"message": "新增成功!"</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">失败返回</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"success": 0,</el-col>
				<el-col :span="24">"message": "新增失败!"</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
		</div>
		
		<!-- </el-scrollbar> -->
	</div>
</template>

<script>
	import myTable from "@/page/platform-module/jog-document/child"
	export default {
		components: {
			myTable
		},
		data() {
			return {
				tableOne: [{
					name: 'token',
					shuoming: 'getToken 获取的token',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}],
				tableTwo: [{
					name: 'recordId',
					shuoming: '该类别监测记录唯一标识',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''

				}, {
					name: 'areaName',
					shuoming: '区域名称',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'idcardno',
					shuoming: '老人身份证',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'type',
					shuoming: '监测类别 :1:血压，2:血糖，3:体重，4:运动，5:睡眠，6:身体指数，7:血脂，8:血尿酸，9:血氧，10:心电，11:呼吸率，12:精神指数，13:皮肤指数,14:体温 , 15:健康护理床位',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'time',
					shuoming: '监测时间yyyy-MM-dd HH:mm:ss',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'collectType',
					shuoming: '来源采集方式CODE，1 APP、2 微信、3 会员网站端',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'deviceType',
					shuoming: '设备型号',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'deviceSid',
					shuoming: '设备串号',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'body',
					shuoming: '监测项目json字符串结构体',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}],

				tableHealth: [{ //健康护理床位
					name: 'deviceSid',
					shuoming: '设备串号',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'heartRate',
					shuoming: '心跳',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'breathe',
					shuoming: '呼吸',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'bodyStatus',
					shuoming: '身体状态 0:无人  1:有人',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'bodyDynamicValue',
					shuoming: '体动值1：有体动 2：无体动',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'batteryCapacity',
					shuoming: '电池电量 0x00~0x64电池实际电量 0xff:在充电',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],

				tableYa: [{ //血压
					name: 'highValue',
					shuoming: '收缩压（高压），单位mmHg M',
					type: 'float',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'

				}, {
					name: 'lowValue',
					shuoming: '舒张压（低压），单位mmHg M',
					type: 'float',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'pulseValue',
					shuoming: '脉率，单位bpm',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'level',
					shuoming: '血压级别 -1:偏低, 0:正常, 1:正常高值,2:1级高血压, 3:2级高血压, 4:3级高血压',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '脉率，单位bpm',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tableTang: [{ //血糖
					name: 'sugarValue',
					shuoming: '血糖值，单位mmol/L',
					type: 'float',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'typeCode',
					shuoming: '血糖类别，如此为空则根据typeDetailCode判断。空腹血糖:1,餐后血糖:2',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'typeDetailCode',
					shuoming: '血糖类别明细。空腹1、早餐后2、午餐前3、午餐后4、晚餐前5、晚餐后6、睡前7、夜间8',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'level',
					shuoming: '血糖级别 0:偏低,1:正常,2:偏高,3:较高,4:过高',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],

				tableWeight: [{ //体重
					name: 'hightVlaue',
					shuoming: '身高，单位cm',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'weightValue',
					shuoming: '体重，单位kg',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'bmi',
					shuoming: '体质指数',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'level',
					shuoming: 'Bmi级别 -1:偏轻,0:正常,1:超重,2:肥胖',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],


				tableBody: [{ //身体指数
						name: 'bodyFatValue',
						shuoming: '体脂率',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'bmi',
						shuoming: 'BMI',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'bmr',
						shuoming: '基础代谢率',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyWater',
						shuoming: '身体水份',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bone',
						shuoming: '骨量',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'skinFat',
						shuoming: '皮下脂肪',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'visceralFat',
						shuoming: '内脏脂肪',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'muscle',
						shuoming: '肌肉比例',
						type: 'float',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyAge',
						shuoming: '身体年龄',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					},
					{
						name: 'level',
						shuoming: '体脂率级别 0:正常,1:偏高,2:偏低',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'levelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bmiLevel',
						shuoming: 'BMI级别 -1:偏轻,0:正常,1:超重,2:肥胖',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bmiLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bmrLevel',
						shuoming: '基础代谢率级别 0:未达标,1:达标',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bmrLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyWaterLevel',
						shuoming: '身体水份级别 1:偏低,2:标准,3:偏高',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyWaterLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'boneLevel',
						shuoming: '骨量级别 1:偏低,2:标准,3:偏高',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'boneLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'skinFatLevel',
						shuoming: '皮下脂肪级别 1:偏低,2:标准,3:偏高',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'skinFatLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'visceralFatLevel',
						shuoming: '内脏脂肪级别 1:标准,2:偏高,3:过高',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'visceralFatLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'muscleLevel',
						shuoming: '肌肉比例级别 1:偏低,2:标准,3:偏高',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'muscleLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyAgeLevel',
						shuoming: '身体年龄级别 1:小于实际年龄,2:等于实际年龄,3:大于实际年龄',
						type: 'int',
						fanwei: '',
						pos: '',
						select: ''
					}, {
						name: 'bodyAgeLevelName',
						shuoming: '',
						type: 'String',
						fanwei: '',
						pos: '',
						select: ''
					}
				],
				tableZhi: [{ //血脂
						name: 'cholValue',
						shuoming: '总胆固醇，单位mmol',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					},
					{
						name: 'trigValue',
						shuoming: '甘油三酯，单位mmol',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'hdlValue',
						shuoming: '高密度脂蛋白胆固醇，单位mmol',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'ldlValue',
						shuoming: '低密度脂蛋白胆固醇，单位mmol',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'Level',
						shuoming: '血脂级别 1:正常,2:异常',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'levelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'cholLevel',
						shuoming: '总胆固醇级别 0:正常,1:偏高',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'cholLevelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'hdlLevel',
						shuoming: '高密度脂蛋白胆固醇级别 0:正常,1:偏低',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'hdlLevelName',
						shuoming: ' ',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'ldlLevel',
						shuoming: '低密度脂蛋白胆固醇级别 0:正常,1:偏高',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'ldlLevelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'trigLevel',
						shuoming: '甘油三酯级别 0:正常,1:偏高',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'trigLevelName',
						shuoming: '高密度脂蛋白胆固醇级别 0:正常,1:偏低',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}
				],

				tableSuan: [{ //血尿酸
					name: 'buaValue',
					shuoming: '血尿酸值，单位μmol/L',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'level',
					shuoming: '血尿酸级别 0:偏低,1:正常,2: 偏高',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tableYang: [{ //血氧
					name: 'spoValue',
					shuoming: '血氧值，单位%',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'level',
					shuoming: '血氧级别 0:低氧血症,1:失饱和状态，2:正常',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tableHert: [{ //心电
						name: 'heartRate',
						shuoming: '心率',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					},
					{
						name: 'leakCount',
						shuoming: '漏博次数',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'stopCount',
						shuoming: '停博次数',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					},
					{
						name: 'irregularCount',
						shuoming: '心律不齐次数',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'fastCount',
						shuoming: '心率过快次数',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'slowCount',
						shuoming: '心率过慢次数',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'filteredEcgPoints',
						shuoming: '心电波形	',
						type: '大字段文本（mediumtext）',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'level',
						shuoming: '心电级别1:疑似窦性停博2:窦性心动过缓3:窦性心动稍缓，窦性心律正常4:窦性心动稍缓，窦性心律不齐5:窦性心动正常，窦性心律不齐6:窦性心动正常7:窦性心动稍快，窦性心律正常8:窦性心动稍快，窦性心律不齐9:窦性心动过快',
						type: 'int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'levelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}
				],
				tableHu: [{ //呼吸
					name: 'breathFreq',
					shuoming: '呼吸率',
					type: 'float',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'level',
					shuoming: '呼吸率级别：1:呼吸过缓,2:正常,3:呼吸过快',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '等级名称',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tableJS: [{ //精神
					name: 'testType',
					shuoming: 'fatigue——精神疲劳 sentiment——情绪指数 resistance——抵抗力',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'level',
					shuoming: '情绪指数-1：正常 2：紧张 3：焦急4：抑郁精神疲劳-1：正常 2：轻度 3：中度4：重度抵抗力-1：好 2：正常 3：下降 4：严重下降',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tablePi: [{ //皮肤
						name: 'waterPercent',
						shuoming: '水份百分比',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'oilPercent',
						shuoming: '油份百分比',
						type: 'float',
						fanwei: 'NA',
						pos: 'path',
						select: '必填'
					}, {
						name: 'bodyPart',
						shuoming: '1——额头 2——眼部 3——脸颊 4——手心 5——手背 6——手腕',
						type: 'Int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'waterPercentLevel',
						shuoming: '水份百分比级别 1:干燥,2:正常,3:湿润',
						type: 'Int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					},
					{
						name: 'waterPercentLevelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'oilPercentLevel',
						shuoming: '油份百分比级别 1:湿润,2:一般,3:偏油',
						type: 'Int',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}, {
						name: 'oilPercentLevelName',
						shuoming: '',
						type: 'String',
						fanwei: 'NA',
						pos: 'path',
						select: ''
					}
				],
				tableWen: [{ //体温
					name: 'bodyTemperature',
					shuoming: '体温',
					type: 'float',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'level',
					shuoming: '体温级别 1:正常,2:低热,3:中度发热,4:高热',
					type: 'int',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'levelName',
					shuoming: '',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, ]
			}
		}
	}
</script>

<style scoped="scoped">
	/* .contain {
		width: 98%;
		margin: 0 auto;
		font-size: 16px;
		overflow-y: scroll;
		height: 800px;
		padding: 10px 0 0 20px;
	}

	::-webkit-scrollbar {
		width: 6px;

	}

	::-webkit-scrollbar-thumb {
		border-radius: 3px;
		height: 100px;
		background-color: #ccc;
	} */
	.contain{
		/* width: 100%; */
		background: #fff;
		padding:20px 30px;
		font-size: 16px;
	}

	.contain .el-row {
		margin-bottom: 10px;
	}


	.contain-bg {
		/* width: 100%; */
		padding: 20px 0 20px 20px;
		background: #f9f9fa;
	}

	.contain-bg .el-col {
		font-size: 14px;
	}

	.bold {
		font-size: 18px;
		font-weight: bold;
	}

	.table-contain {
		margin: 20px 0;
	}

	.bold-head {
		font-size: 20px;
		font-weight: bold;
		margin-bottom:20px;
	}
</style>
